import { useClock } from "../store/clock-store";

interface ClockFormattedProps {
    variant: 'time' | 'date' | 'datetime';
    options?: Intl.DateTimeFormatOptions;
}

export const ClockFormatted: React.FC<ClockFormattedProps> = ({ variant, options }) => {
    const now = useClock();

    if (variant === 'time') {
        return <>{now.toLocaleTimeString("cs-CZ", options)}</>;
    }

    if (variant === 'date') {
        return <>{now.toLocaleDateString("cs-CZ", options)}</>;
    }

    return <>{now.toLocaleString("cs-CZ", options)}</>;
};
